import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown", "badge"]

  connect() {
    this._open = false
    this._dropdown = this.dropdownTarget
    this._badge = this.badgeTarget
    this._onClickOutside = this._handleClickOutside.bind(this)
    document.addEventListener("click", this._onClickOutside)
    this._refreshBadge()
    // Move dropdown to body so it escapes sidebar's transform containing block
    document.body.appendChild(this._dropdown)
    // Poll every 60 seconds for new notifications
    this._interval = setInterval(() => this._refreshBadge(), 60000)
  }

  disconnect() {
    document.removeEventListener("click", this._onClickOutside)
    clearInterval(this._interval)
    if (this._dropdown.parentElement === document.body) {
      this._dropdown.remove()
    }
  }

  toggle(event) {
    event.stopPropagation()
    this._open = !this._open

    if (this._open) {
      this._loadDropdown()
      this._positionDropdown()
      this._dropdown.classList.remove("hidden")
    } else {
      this._dropdown.classList.add("hidden")
    }
  }

  _positionDropdown() {
    const rect = this.element.getBoundingClientRect()
    const dropdown = this._dropdown
    dropdown.style.position = "fixed"
    dropdown.style.left = `${rect.left}px`
    dropdown.style.bottom = `${window.innerHeight - rect.top + 8}px`
  }

  _loadDropdown() {
    fetch("/notifications/dropdown", {
      headers: { "Accept": "text/html" }
    })
    .then(r => r.text())
    .then(html => {
      this._dropdown.innerHTML = html
    })
  }

  _refreshBadge() {
    fetch("/notifications/unread_count", {
      headers: { "Accept": "text/html" }
    })
    .then(r => r.text())
    .then(html => {
      this._badge.innerHTML = html
    })
  }

  _handleClickOutside(event) {
    if (!this.element.contains(event.target) && !this._dropdown.contains(event.target) && this._open) {
      this._open = false
      this._dropdown.classList.add("hidden")
    }
  }
}
